/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 *
 * @export
 * @interface HelpDataSearchData
 */
export interface HelpDataSearchData {
  /**
   *
   * @type {string}
   * @memberof HelpDataSearchData
   */
  registryType?: string
  /**
   *
   * @type {string}
   * @memberof HelpDataSearchData
   */
  name?: string
  /**
   *
   * @type {boolean}
   * @memberof HelpDataSearchData
   */
  hideNonActive?: boolean
  /**
   *
   * @type {string}
   * @memberof HelpDataSearchData
   */
  searchScope?: string
  /**
   *
   * @type {string}
   * @memberof HelpDataSearchData
   */
  registrationOfficeCode?: string
  /**
   *
   * @type {string}
   * @memberof HelpDataSearchData
   */
  registrationNumber?: string
  /**
   *
   * @type {string}
   * @memberof HelpDataSearchData
   */
  applicationNumber?: string
  /**
   *
   * @type {string}
   * @memberof HelpDataSearchData
   */
  owner?: string
  /**
   *
   * @type {string}
   * @memberof HelpDataSearchData
   */
  correspondenceAddress?: string
  /**
   *
   * @type {Array<number>}
   * @memberof HelpDataSearchData
   */
  mktuClasses?: Array<number>
  /**
   *
   * @type {number}
   * @memberof HelpDataSearchData
   */
  page?: number
  /**
   *
   * @type {number}
   * @memberof HelpDataSearchData
   */
  perPage?: number
}

/**
 * Check if a given object implements the HelpDataSearchData interface.
 */
export function instanceOfHelpDataSearchData(
  value: object
): value is HelpDataSearchData {
  return true
}

export function HelpDataSearchDataFromJSON(json: any): HelpDataSearchData {
  return HelpDataSearchDataFromJSONTyped(json, false)
}

export function HelpDataSearchDataFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): HelpDataSearchData {
  if (json == null) {
    return json
  }
  return {
    registryType:
      json['registryType'] == null ? undefined : json['registryType'],
    name: json['name'] == null ? undefined : json['name'],
    hideNonActive:
      json['hideNonActive'] == null ? undefined : json['hideNonActive'],
    searchScope: json['searchScope'] == null ? undefined : json['searchScope'],
    registrationOfficeCode:
      json['registrationOfficeCode'] == null
        ? undefined
        : json['registrationOfficeCode'],
    registrationNumber:
      json['registrationNumber'] == null
        ? undefined
        : json['registrationNumber'],
    applicationNumber:
      json['applicationNumber'] == null ? undefined : json['applicationNumber'],
    owner: json['owner'] == null ? undefined : json['owner'],
    correspondenceAddress:
      json['correspondenceAddress'] == null
        ? undefined
        : json['correspondenceAddress'],
    mktuClasses: json['mktuClasses'] == null ? undefined : json['mktuClasses'],
    page: json['page'] == null ? undefined : json['page'],
    perPage: json['perPage'] == null ? undefined : json['perPage'],
  }
}

export function HelpDataSearchDataToJSON(
  value?: HelpDataSearchData | null
): any {
  if (value == null) {
    return value
  }
  return {
    registryType: value['registryType'],
    name: value['name'],
    hideNonActive: value['hideNonActive'],
    searchScope: value['searchScope'],
    registrationOfficeCode: value['registrationOfficeCode'],
    registrationNumber: value['registrationNumber'],
    applicationNumber: value['applicationNumber'],
    owner: value['owner'],
    correspondenceAddress: value['correspondenceAddress'],
    mktuClasses: value['mktuClasses'],
    page: value['page'],
    perPage: value['perPage'],
  }
}
